import React, { useCallback, useState, useContext } from 'react'
import { APITokenInfo, Organizationinfo } from '@/types'
import { Row } from '../components'
import Table, { pageProps, ColumnAction } from '@/components/Table'
import { apiTokenColumns } from './column'
import { ConfirmButton } from '@/components/Button'
import { getAPIToken, deleteAPIToken } from '@/api'
import { useQuery, useMutation } from '@tanstack/react-query'
import { confirm } from '@/components/Modal'
import { AuthContext } from '@/layout/Auth'
import { ensureSecurityGate } from '@/utils/securityGate'
export interface APITokenProps {
  onAdd: () => void
  orgInfo: Organizationinfo
}

const APITokenList: React.FC<APITokenProps> = (props) => {
  const { onAdd, orgInfo } = props
  const [total, setTotal] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [data, setData] = useState<APITokenInfo[]>([])
  const [rows, setRows] = useState<number>(10)
  const { authInfo } = useContext(AuthContext)
  const queryApiTokens = useQuery(
    ['getAPIToken', orgInfo?.id, page, rows],
    () =>
      getAPIToken({
        id: orgInfo?.id,
        query: { page, size: rows },
      }),
    {
      onSuccess: (res) => {
        setTotal(res.total)
        setData(res.data)
      },
      refetchOnMount: true,
      enabled: !!orgInfo?.id,
    },
  )

  const deleteApiTokenMutation = useMutation(deleteAPIToken, {
    onSuccess: () => {
      queryApiTokens.refetch()
    },
  })

  const handlePageChange = (value: pageProps) => {
    setPage(value.page)
    // @ts-ignore
    setRows(value.rowsPerPage)
  }

  const columnsAction = useCallback(
    (action: ColumnAction, data: APITokenInfo) => () => {
      switch (action) {
        case 'delete': {
          confirm({
            title: '提示',
            content: '确认删除此API Token',
            // @ts-ignore
            onClose: null,
            onConfirm: async () => {
              if (!(await ensureSecurityGate('api_token'))) return
              deleteApiTokenMutation.mutate({
                // @ts-ignore
                org_id: authInfo?.orgInfo?.id,
                id: data.id,
              })
            },
            closeAfterClose: true,
          })
          break
        }
        case 'edit': {
          break
        }
      }
    },
    [deleteApiTokenMutation],
  )

  return (
    <>
      <Row sx={{ justifyContent: 'flex-end', gap: '24px' }}>
        <ConfirmButton onClick={onAdd}>生成API Token</ConfirmButton>
      </Row>
      <Table<APITokenInfo>
        sx={{ flex: 1 }}
        columns={apiTokenColumns(columnsAction)}
        data={data}
        rowKey={'id'}
        pagination={{
          page,
          total,
          onChange: handlePageChange,
          rowsPerPage: rows,
        }}
      />
    </>
  )
}

export default APITokenList
